import React, { useContext } from "react";
import styled from "styled-components";
import {
  MessageContext,
  Message,
  MessageType,
} from "../Contexts/MessageContext";
import { useTheme } from "emotion-theming";

export const Messages = () => {
  const messageContext = useContext(MessageContext);

  return (
    <MessageContainer>
      {messageContext.activeMessages.map((message) => (
        <div key={message.id}>
          <SingleMessage m={message} />
        </div>
      ))}
    </MessageContainer>
  );
};

const MessageContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  text-align: right;
  z-index: 1000;
`;

const SingleMessage: React.FC<{ m: Message }> = ({ m }) => {
  const theme: any = useTheme();

  const ColorMap = {
    [MessageType.success]: theme.colors.primary,
    [MessageType.danger]: theme.colors.danger,
    [MessageType.warn]: theme.colors.warn,
  };

  return <MessageCard color={ColorMap[m.type]}>{m.msg}</MessageCard>;
};

const MessageCard = styled.div<{ color: string }>`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation-duration: 3s;
  animation-name: fadeIn;
  padding: 4px 14px 4px 14px;
  background-color: white;
  border: 2px solid ${(props) => props.color};
  border-radius: 4px;
  margin: 4px;
  font-weight: bold;
  display: inline-block;
  min-width: 150px;
  text-align: left;
`;
